import React, { useMemo } from 'react';

import { GetUserByEmailParams, getUserByEmailService } from '@mygpt/app/users/services';

export const useGetUserByEmail = () => {
  const [loading, setLoading] = React.useState(false);

  const getUserByEmail = React.useCallback(async (params: GetUserByEmailParams) => {
    setLoading(true);
    return getUserByEmailService(params).finally(() => {
      setLoading(false);
    });
  }, []);

  return useMemo(() => ({ loading, getUserByEmail }), [loading, getUserByEmail]);
};
